///<reference path="../../common/decorators.ts"/>
namespace TotalCore.Dashboard.Components {
    import Component = TotalCore.Common.Component;

    @Component('components.dashboard', {
        templateUrl: 'dashboard-subscribe-component-template',
        bindings: {}
    })
    class DashboardSubscribeComponent {

    }
}